import themesTab from './themesTab';

export default [
  themesTab,
];
